module.exports = __webpack_public_path__ + "static/img_1143-f205dacc638841105cbb8d04b2ac37f4.webp";